import React from 'react'

import Dropdown from '@/components/ui/dropdown/Dropdown'

interface CustomNumberInputProps {
  label: string
  value: string | number
  max?: number
  defaultValue?: number
  placeholder?: string
  onChange: (value?: string | number) => void
  units?: { label: string; value: string; isDefault?: boolean }[]
}

const CustomNumberInput = ({
  label,
  value,
  placeholder = 'Enter a value...',
  onChange,
  units,
  max,
  defaultValue,
}: CustomNumberInputProps) => {
  const numericValue = typeof value === 'number' ? value : parseInt(value || '', 10)
  const unitFromValue =
    units && units.length > 0 ? units.find((u) => numericValue && String(value).endsWith(u.value))?.value : undefined

  const [inputValue, setInputValue] = React.useState<number | undefined>(numericValue ?? defaultValue ?? 0)
  const [selectedUnit, setSelectedUnit] = React.useState<string | undefined>(
    unitFromValue ?? (units && units.length > 0 ? units[0].value : undefined)
  )

  const formattedValue = (value?: number, unit?: string) => {
    if (value && unit) {
      return `${value}${unit}`
    }
    return value ?? 0
  }

  return (
    <div className="mb-4">
      <label className="block text-base-content mb-2">{label}</label>
      <div className="flex flex-col sm:flex-row gap-4">
        <input
          type="number"
          max={max}
          className="input input-bordered text-base border-base-300 w-[53%] focus:outline-none focus:border-primary/30"
          value={inputValue ? parseInt(inputValue.toString(), 10) : ''}
          onChange={(e) => {
            let newValue = e.target.value ? parseInt(e.target.value, 10) : 0
            if (max !== undefined && newValue > max) {
              newValue = max
            }
            if (newValue < 0) {
              newValue = 0
            }
            setInputValue(newValue)
            onChange(formattedValue(newValue, selectedUnit))
          }}
          placeholder={placeholder}
          onFocus={(e) => e.target.select()}
          inputMode="numeric"
        />
        {units && (
          <div className="w-[47%]">
            <Dropdown
              options={units}
              handleSingleSelectItem={(opt: { label: string; value: string } | null) => {
                setSelectedUnit(opt ? opt.value : undefined)
                onChange(formattedValue(inputValue, opt ? opt.value : undefined))
              }}
              selectedItem={units.find((o) => o.value === selectedUnit) || units.find((o) => o.isDefault) || units[0]}
              placeholder={placeholder}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomNumberInput
